import understandingPetNutrition from './2025-01-understanding-pet-nutrition';
import completePetHealthRecordGuide from './2025-01-complete-pet-health-record-guide';
import petHealthCheckupGuide from './2026-04-pet-health-checkup-guide';
import petGroomingCompleteGuide from './2026-04-pet-grooming-complete-guide';
import multiPetHouseholdManagement from './2026-01-multi-pet-household-management';
import seniorPetCareGuide from './2026-02-senior-pet-care-guide';
import petEmergencyPreparedness from './2026-03-pet-emergency-preparedness';
import petTravelCompleteGuide from './2026-05-pet-travel-complete-guide';

export const articlesZh = [
  petTravelCompleteGuide,
  petGroomingCompleteGuide,
  petHealthCheckupGuide,
  petEmergencyPreparedness,
  seniorPetCareGuide,
  multiPetHouseholdManagement,
  completePetHealthRecordGuide,
  understandingPetNutrition
];